import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

import { APP_CONFIG, ITimeZone } from '@ideals/types';

const RUSSIA_CODE = 'RU';
const IRAN_CODE = 'IR';
const NORTH_KOREA_CODE = 'KP';
const VENEZUELA_CODE = 'VE';
const CUBA_CODE = 'CU';
const BELARUS_CODE = 'BY';
const SYRIA_CODE = 'SY';
const MYANMAR_CODE = 'MM';

export const BANNED_COUNTRY_CODES = [
  RUSSIA_CODE,
  IRAN_CODE,
  NORTH_KOREA_CODE,
  VENEZUELA_CODE,
  CUBA_CODE,
  BELARUS_CODE,
  SYRIA_CODE,
  MYANMAR_CODE,
];

@Injectable({ providedIn: 'root' })
export class GeoService {
  readonly #appConfig = inject(APP_CONFIG);
  readonly #httpClient = inject(HttpClient);

  #timeZone$: Observable<ITimeZone>;

  get isBannedLocation(): Observable<boolean> {
    return this.getTimeZone()
      .pipe(
        map(({ countryCode }) => BANNED_COUNTRY_CODES.includes(countryCode)),
      );
  }

  getTimeZone(): Observable<ITimeZone> {
    if (!this.#timeZone$) {
      this.#timeZone$ = this.#loadTimeZone();
    }

    return this.#timeZone$;
  }

  #loadTimeZone(): Observable<ITimeZone> {
    return this.#httpClient.get<ITimeZone>(`${this.#appConfig.ssoUrl}/api/location`)
      .pipe(
        catchError(() => of({} as ITimeZone)),
        shareReplay(),
      );
  }
}
